const getTextColor = (color) => {
  const hexColor = color.replace('#', '0x');
  return (parseInt(hexColor, 16) > 0xffffff / 2) ? '#000000' : '#FFFFFF';
};

export default getTextColor;
